import helper from "../../common/Helper";
import noProfile from "../../assest/myImages/noprofile.png";
import moment from "moment";

const Index = ({ state, setIsEdit }) => {
    return (
        <div className="rightProfile backLayerCom">
            <div className="importTitle">
                <h4 className="commonh3">Profile details</h4>
            </div>
            <div className="rightProfileMain">
                <div className="ourdetailProfile">
                    <div className="userImgBox">
                        <img src={helper.S3Url + '/' + helper.profileImageDir + '/' + state?.profile_picture}
                            alt="noprofile"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = noProfile
                            }}
                        />
                    </div>
                    <div className="userPersonaldet">
                        <ul className="userUlList">
                            <li><span><i className="fa-solid fa-user"></i> First name </span> <span className="black">{state.first_name}</span></li>
                            <li><span><i className="fa-solid fa-user"></i> Last name </span> <span className="black">{state.last_name}</span></li>
                            <li><span><i className="fa-solid fa-envelope"></i> Email </span> <span className="black">{state.email}</span></li>
                            <li><span><i className="fa-solid fa-phone-volume"></i> Phone number </span> <span className="black">{state.phone}</span></li>
                            <li><span><i className="bi bi-calendar-week-fill"></i> Birth date </span> <span className="black">{state.birth_date? 
                            moment(state.birth_date).format('DD-MM-YYYY') : '-'}</span></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="continueBox">
                <button className="btn continueBtn" onClick={() => setIsEdit(true)}><i className="fa-solid fa-pen"></i> Edit</button>
            </div>
        </div>
    )
}
export default Index;